import React from 'react';

const UsersContext = React.createContext({
    Users: [],
    setUsers: () => { }
})

export default UsersContext;